<template>
  <div id="app">
    <router-view> </router-view>
    <GlobalAudioPlayer @vue:mounted="() => console.log('🎵 App.vue - GlobalAudioPlayer montado')" />
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';
import GlobalAudioPlayer from '@/components/GlobalAudioPlayer.vue';

export default {
  name: "MiOrsai",
  components: {
    GlobalAudioPlayer
  },
  async mounted() {
    console.log('🚀 App.vue montado, iniciando inicialización de autenticación...');
    console.log('📄 Cookies al inicio:', document.cookie);
    
    try {
      // Inicializar la autenticación cuando la aplicación se monta
      const authStore = useAuthStore();
      console.log('🏪 Store de autenticación obtenido');
      
      // Pequeño delay para asegurar que el store esté completamente inicializado
      await new Promise(resolve => setTimeout(resolve, 100));
      
      await authStore.inicializarAuth();
      console.log('✅ Inicialización de autenticación completada');
      
      // Verificar estado final
      console.log('🔍 Estado final del store:', {
        usuario: authStore.usuario?.email,
        isAuthenticated: authStore.isAuthenticated,
        token: authStore.token ? 'EXISTS' : 'MISSING'
      });
      
      // Hacer el store disponible globalmente para debugging
      window.authStore = authStore;
      window.debugAuth = () => {
        console.log('🔍 === DEBUG GLOBAL ===');
        console.log('📄 Cookies:', document.cookie);
        console.log('🍪 orsai_token:', getCookie('orsai_token'));
        console.log('🏪 Store:', authStore);
        console.log('👤 Usuario:', authStore.usuario);
        console.log('🔐 isAuthenticated:', authStore.isAuthenticated);
        console.log('🔍 === FIN DEBUG ===');
      };
      
      // Función para forzar reinicialización
      window.reinitAuth = async () => {
        console.log('🔄 Reinicializando autenticación...');
        await authStore.inicializarAuth();
        console.log('✅ Reinicialización completada');
      };
    } catch (error) {
      console.error('❌ Error en inicialización de autenticación:', error);
    }
  }
};

// Función auxiliar para obtener cookies
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
    return null;
}
</script>

<style></style>
